<!-- appointment-summary.component.html -->
<div class="appointment-summary h-full px-8 py-8 flex flex-col justify-between" *ngIf="appointment">
  <div class="">
  <div *ngFor="let detail of details" class="mt-2 border-b-2 border-gray-300 py-6 " (touchstart)="toggleAdditionalsFordetail(detail)" (click)="toggleAdditionalsFordetail(detail)">
    
      <div class="flex justify-between">
        <div class="flex">
          <div class="icon w-6 h-6">
            <ng-container *ngIf="isFaIcon(detail.icon); else svgIcon">
              <!-- FontAwesome icon -->
              <fa-icon [icon]="detail.icon"></fa-icon>
            </ng-container>
            <ng-template #svgIcon>
              <!-- Inline SVG string -->
              <div [innerHTML]=" toSafeHtml(detail.icon) "></div>
            </ng-template>
          </div>
          <div class="pl-3">
            <div class="font-bold">{{ detail.title }}</div>
            <div class="text-light-text text-sm" [innerHTML]=" toSafeHtml(detail.subtitle) "></div>
          </div>
      </div>

        <div class="flex flex-col justify-center">
          <div *ngIf="detail.additionals" >
            <fa-icon *ngIf="detail.additionalsOpen" [icon]="faChevronUp"></fa-icon>
            <fa-icon *ngIf="!detail.additionalsOpen" [icon]="faChevronDown"></fa-icon>
          </div>
        </div>
    </div>


    <div class="" *ngIf="detail.additionals && detail.additionalsOpen">
      <div class="flex py-3" *ngFor="let additional of detail.additionals">
        <div class="w-6"></div>
        <div class="pl-3">
          <div class="font-bold text-sm">{{ additional.title }}</div>
          <div class="text-sm" [innerHTML]=" toSafeHtml(additional.value)"></div>
        </div>
      </div>
    </div>
  

  

  </div>
  </div>

  <div class="flex justify-end mt-12">
        <button type="button" (click)="editClicked()" (touchstart)="editClicked()" class="close-btn flex gap-2 border border-accent px-6 py-2 rounded-md hover:bg-accent hover:text-white">
            
            
            <svg class="h-6 w-6 " viewBox="0 0 24 24" fill="currentColor" class="size-6">
          <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
          <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
        </svg>

        <span>Edit Details</span>

          </button>
    </div>
</div>